var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-button',{on:{"click":_vm.addAdmin}},[_vm._v("Set Admin")]),_vm._v(" "),_c('b-button',{on:{"click":_vm.addCoordinator}},[_vm._v("Set Travel Coordinator")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }